import { React, useState, useEffect, useRef } from "react";
import "./DragDrop.css";
import { MdFileUpload, MdClose } from "react-icons/md";
import { useDropzone } from "react-dropzone";
import MopsBoard from "./MopsBoard";
import { useGlobalContext } from "../context";
import { Link } from "react-router-dom";
import ColorPicker from "./ColorPicker";
const Chess = require("chess.js");
let chess = new Chess();

const DragDrop = () => {
  const { setStartPosition, showColorPicker, setShowColorPicker } =
    useGlobalContext();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [files, setFiles] = useState([]);

  let uploadBtnRef = useRef();
  useEffect(() => {
    uploadBtnRef.current.removeAttribute("disabled");
  }, []);

  // Set choosen image and create url
  const setImage = (images) => {
    setFiles(
      images.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  };

  // Paste an image from clipboard
  document.onpaste = (e) => {
    let items = e.clipboardData.items;
    if (
      items.length === 1 &&
      items[0].kind === "file" &&
      items[0].type.match("image/*")
    ) {
      setImage([items[0].getAsFile()]);
    }
  };

  // Drag and drop file or search in users device
  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: "image/*",
    onDrop: (acceptedFile) => {
      setImage(acceptedFile);
    },
  });

  // Preview an image before upload
  const images = files.map((file) => {
    return (
      <div key={file.name}>
        <img src={file.preview} alt="preview" className="image-preview" />
      </div>
    );
  });

  const [mopsFen, setMopsFen] = useState(
    "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
  );
  const [isBoardReady, setIsBoardReady] = useState(false);
  const [firstFen, setFirsFen] = useState(" ");
  const [errorOccured, setErrorOcurred] = useState(false);

  async function handleUpload() {
    uploadBtnRef.current.setAttribute("disabled", "disabled");
    setIsModalOpen(true);
    let formData = new FormData();
    formData.append("image", files[0]);

    // https://chess-tutor-api.herokuapp.com
    await fetch("https://chess-tutor-api.herokuapp.com/mops_image/", {
      method: "POST",
      credentials: "omit",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.error) {
          setErrorOcurred(true);
        } else {
          setMopsFen(data.fen);
          setFirsFen(data.fen);
          setIsBoardReady(true);
        }
      });
  }

  // Hide modal
  const hideModal = () => {
    uploadBtnRef.current.removeAttribute("disabled");
    setIsModalOpen(false);
    setIsBoardReady(false);
    setErrorOcurred(false);
    setFiles([]);
  };

  const [message, setMessage] = useState(" ");
  const updateMessage = (message) => {
    setMessage(" ");
    setMessage(message);
    setTimeout(() => {
      setMessage(" ");
    }, 1000);
  };

  const [disableBtn, setDisableBtn] = useState(false);
  useEffect(() => {
    let x = mopsFen;
    x = x.split(" ");
    chess.turn() === "w" ? (x[1] = "b") : (x[1] = "w");
    chess.load(x.join(" "));
    const isInvalid = chess.in_check();
    chess.load(mopsFen);

    if (
      (mopsFen.split(" ")[0].match(/k/g) || []).length === 1 &&
      (mopsFen.split(" ")[0].match(/K/g) || []).length === 1
    ) {
      if (chess.load(mopsFen) && !chess.game_over() && !isInvalid) {
        setDisableBtn(false);
      } else {
        setDisableBtn(true);
      }
    } else {
      setDisableBtn(true);
    }
  }, [mopsFen]);

  const [color, setColor] = useState("w");
  useEffect(() => {
    let x = mopsFen.split(" ");
    x[1] = color;
    setMopsFen(x.join(" "));
  }, [color]);

  const [castle, setCastle] = useState({ K: true, Q: true, k: true, q: true });
  useEffect(() => {
    let castleString = "";
    // console.log(castle);
    for (const prop in castle) {
      castle[prop] ? (castleString += prop) : (castleString += "");
    }
    if (!castleString) {
      castleString = "-";
    }
    let x = mopsFen.split(" ");
    x[2] = castleString;
    setMopsFen(x.join(" "));
  }, [castle]);

  const changeBoardDirection = () => {
    let fen = mopsFen.split(" ");
    let reverse = fen[0].split("/").reverse().join("/");
    console.log(reverse);
    fen[0] = reverse;
    // console.log(fen.join(" "));
    setMopsFen(fen.join(" "));
  };

  return (
    <>
      <div className={`${!isModalOpen ? "modal hide-modal" : "modal"}`}>
        <div
          className={`${
            showColorPicker ? "modal-content modal-in" : "modal-content"
          }`}
        >
          <button className="modal-close-btn" onClick={() => hideModal()}>
            <MdClose />
          </button>
          {errorOccured && (
            <div className="upload-fail">
              Nie udało się odtworzyć pozycji szachowej z danego obrazu.
            </div>
          )}
          {isBoardReady && (
            <div>
              <p>
                <b>
                  Pierwotny FEN:<br></br>
                </b>
                {firstFen}
              </p>

              <p className="fen-message">
                {" "}
                {(firstFen.split(" ")[0].match(/k/g) || []).length > 1 ||
                (firstFen.split(" ")[0].match(/K/g) || []).length > 1
                  ? "Odtworzona pozycja posiadała więcej niż jednego króla w danym kolorze, zatem ich liczba została zredukowana"
                  : " "}
              </p>
              <p>
                <b>
                  Zaktualizowany FEN:<br></br>
                </b>{" "}
                {mopsFen}
              </p>
              <p className="message">{message}</p>
              <div className="mops-board-section">
                <MopsBoard
                  updateMessage={updateMessage}
                  setMopsFen={setMopsFen}
                  mopsFen={mopsFen}
                />
                <div className="start-from-position-btns">
                  <div
                    className="btn board-direction-btn"
                    onClick={() => changeBoardDirection()}
                  >
                    <h5>Odwróć szachownicę</h5>
                  </div>
                  <div className="start-from-position-settings">
                    <div className="color-settings">
                      <h5
                        onClick={() => setColor("w")}
                        style={{ opacity: `${color === "w" ? "1" : 0.5}` }}
                      >
                        Ruch białych
                      </h5>
                      <h5
                        onClick={() => setColor("b")}
                        style={{ opacity: `${color === "b" ? "1" : 0.5}` }}
                      >
                        Ruch czarnych
                      </h5>
                    </div>
                    <h5 className="castle-header">Roszady:</h5>
                    <div className="castle-settings">
                      <h5>Białe:</h5>
                      <div className="single-color-castle">
                        <h5
                          onClick={() => {
                            setCastle({ ...castle, K: !castle.K });
                          }}
                          style={{ opacity: `${castle.K ? "1" : 0.5}` }}
                        >
                          O-O
                        </h5>
                        <h5
                          onClick={() => {
                            setCastle({ ...castle, Q: !castle.Q });
                          }}
                          style={{ opacity: `${castle.Q ? "1" : 0.5}` }}
                        >
                          O-O-O
                        </h5>
                      </div>

                      <h5>Czarne:</h5>
                      <div className="single-color-castle">
                        <h5
                          onClick={() => {
                            setCastle({ ...castle, k: !castle.k });
                          }}
                          style={{ opacity: `${castle.k ? "1" : 0.5}` }}
                        >
                          O-O
                        </h5>
                        <h5
                          onClick={() => {
                            setCastle({ ...castle, q: !castle.q });
                          }}
                          style={{ opacity: `${castle.q ? "1" : 0.5}` }}
                        >
                          O-O-O
                        </h5>
                      </div>
                    </div>
                  </div>

                  <button
                    disabled={disableBtn}
                    className="btn start-btn"
                    onClick={() => {
                      {
                        setStartPosition(mopsFen);
                      }
                    }}
                  >
                    <Link to="/training" className="mops-link">
                      Rozpocznij trening od tej pozycji
                    </Link>
                  </button>
                  <button
                    disabled={disableBtn}
                    className="btn start-btn"
                    onClick={() => {
                      setShowColorPicker(true);
                    }}
                  >
                    Rozpocznij grę od tej pozycji
                  </button>
                </div>
              </div>
            </div>
          )}
          {!isBoardReady && !errorOccured && (
            <div className="loading">
              <h3>Przetwarzam obraz</h3>
              <div className="loading-dots"></div>
            </div>
          )}
        </div>
      </div>
      <div className={`${isModalOpen ? "block-drop" : ""}`}>
        <div className="drop-field" {...getRootProps()}>
          {!isModalOpen && <input {...getInputProps()} />}
          <h3 className="drop-text">
            <span className="drop-icon">
              <MdFileUpload />
            </span>
            Kliknij aby dodać plik, lub upuść go tutaj
          </h3>
          <h5
            className="drop-text"
            style={{ fontSize: "1rem", marginBottom: "3rem" }}
          >
            Możesz również wkleić plik ze schowka
          </h5>
          {images}
        </div>
        <div className="upload-btn-container">
          <button
            ref={uploadBtnRef}
            className={`${
              files.length === 0 ? "btn btn-blue hide-btn" : "btn btn-blue"
            }`}
            onClick={() => handleUpload()}
          >
            Wczytaj pozycję z obrazu
          </button>
        </div>
      </div>
      {showColorPicker && <ColorPicker chess={chess} fen={mopsFen} />}
    </>
  );
};

export default DragDrop;
